import { z } from "zod";
import { SETTLEMENT_STATUSES } from "@/features/payroll/schemas/settlement.schema";

/// URL search params for `/$workspaceSlug/payroll/settlements` (PAYD-FR-030
/// to FR-034).
///
/// `q`, `status` and `member` ride the URL (S3): "every unpaid settlement" and
/// "Priya's worksheet" are both links one admin sends another. There is no
/// drawer param here: a settlement is a page, not a panel, because it is the
/// document somebody signs off before money moves.
export const settlementsRouteSearchSchema = z
  .object({
    q: z.string().optional().catch(undefined),
    status: z.enum(SETTLEMENT_STATUSES).optional().catch(undefined),
    member: z.string().optional().catch(undefined),
  })
  .strict();

export type SettlementsRouteSearch = z.infer<typeof settlementsRouteSearchSchema>;
